<template>
    <b-row class="w-100 d-flex justify-content-center align-items-center" style="padding-top: 10px; height:80%; margin: 0;">
        <loading :active="loading"
             :is-full-page="false"/>
        <div v-if="thereIsNoData" class="d-flex align-items-center justify-content-center" style="height: 80%; width: 100%;">
            <span style="font-size: 1.125rem; font-weight: bold;">No Data</span>
        </div>
        <apexchart v-if="series && !thereIsNoData" id="chart" style="flex:1;"
        width="100%" height="90%" ref="apexchart" 
        :options="chartOptions" 
            :series="series" />
    </b-row>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import {generateLabelDateArray, getProjectPeriodByHistory, getHistoryGroupByStatus} from '@/components/chatter/util/graphUtils';
export default {
    name: 'ProgramCreationDateDistributionGraph',
    props: [
        'dashboardData',
        'filters',
        'isFlexible'
    ],
    components: {
        apexchart: VueApexCharts
    },
    mounted() {
        // this.setSeries();
        // this.setLabels();
        
        this.historyData = getHistoryGroupByStatus(this.dashboardData.history);

        if(this.historyData.length <= 0) {
            this.thereIsNoData = true;
        } else {
            this.startDate = this.dashboardData.projectInfo.startDate;
            this.endDate = this.dashboardData.projectInfo.endDate;

            // 시작, 종료 날짜 둘중 하나라도 비어있으면 히스토리에서 시작, 종료 가져옴
            if(this.startDate == '' || this.endDate == '') {
                const [historyStart, historyEnd] = getProjectPeriodByHistory(this.historyData);

                this.startDate = historyStart;
                this.endDate = historyEnd;
            }
            this.reloadGraph();
        }
    },

    watch: {
        filters: {
            deep: true,
            immediate: false,

            handler() {
                console.log("modify filter reload");
                
                this.series = [];
                this.chartOptions.xaxis.categories = [];
                this.reloadGraph();
            }
        },
    },
    data() {
        return {
            thereIsNoData : false,
            loading: false,
            labelArray: '',
            startDate: '',
            endDate: '',
            historyData: '',
            columnNames: [],
            series: [],
            dateRange : [],
            avg:0,
            chartOptions: {
                chart: {
                    type: 'bar',
                    toolbar: {
                        show: this.isFlexible,
                        offsetX: 0,
                        offsetY: 0,
                        tools: {
                            download: true,
                            selection: true,
                            zoom: true,
                            zoomin: true,
                            zoomout: true,
                            pan: true,
                            reset: true | '<img src="/static/icons/reset.png" width="20">',
                            customIcons: []
                        },
                        export: {
                            csv: {
                                filename: undefined,
                                columnDelimiter: ',',
                                headerCategory: 'category',
                                headerValue: 'value',
                                dateFormatter(timestamp) {
                                return new Date(timestamp).toDateString()
                                }
                            },
                            svg: {
                                filename: undefined,
                            },
                            png: {
                                filename: undefined,
                            }
                        }
                    },
                },
                colors: ['#1BD4D4', '#142459'],
                annotations:{
                    yaxis: [
                        {
                            y: 0,
                            borderColor: '#142459',
                            strokeDashArray: 3,
                            borderWidth:3
                            // label: {
                            //     show:this.isFlexible,
                            //     // borderWidth: '3',
                            //     borderColor: '#142459',
                            //     style: {
                            //         color: '#fff',
                            //         background: '#142459'
                            //     },
                            //     text: '평균 프로그램 개수'
                            // }
                        }
                    ]
                },
                series: [],
                plotOptions: {
                    bar: {
                    columnWidth: "95%",
                    // strokeWidth: 2,
                    // borderRadius: 5,
                    // borderRadiusApplication: "end",
                    }
                },
                // fill: {
                //     colors: '#ff4040',
                //     opacity: 0.3,
                // },
                // stroke: {
                //     width: 2,
                //     colors: ['#ee8080']
                // },
                dataLabels: { enabled: false },
                grid: {
                    xaxis: {
                        lines: {
                            show: this.isFlexible
                        }
                    },
                    yaxis: {
                        lines: {
                            show: false
                        }
                    }
                },
                xaxis: {
                    type: "numeric",
                    min: 0,
                    max: 0,
                    // tickPlacement: 'on',
                    categories: [],
                    tickAmount: 0,
                    labels: { 
                        show : this.isFlexible,
                        formatter: x => {
                            return this.labelArray[x]
                        }
                        
                        // x => x /*Math.round(x)*/ 
                    },
                    // title: { text: "Hours", offsetY: 70 },
                    // axisBorder: {
                    //     color: "#000000"
                    // }
                    },
                yaxis: {
                    // title: { text: "Visitors" },
                    // min: 0,
                    // max: 0, //Math.max(...countArray),
                    labels: {
                        show: this.isFlexible
                    },
                    axisBorder: {
                        show: this.isFlexible,
                        // color: "#000000"
                    }
                },
                legend: {
                    show: true,
                    showForSingleSeries: true,
                    position:'bottom',
                    horizontalAlign: "center",
                    offsetX: 0,
                    offsetY: this.isFlexible ? 7 : 3,
                    fontSize: this.isFlexible ? '14px' : '12px'
                },
                tooltip: {
                    onDatasetHover: {
                    highlightDataSeries: true,
                    },
                    x: { formatter: x => { 
                        return this.labelArray[x - 0.5] + ' ~ ' + this.labelArray[x + 0.5];
                    }}
                }
            },
            tableData: [],
        }
    },
    methods: {
        getLabelArray() {
            let dateArray = [];

            // 프로젝트 정보의 startDate, endDate가 없을 때
            // 데이터의 label 정보로 초기화
            let from = this.startDate;
            let to = this.endDate;

            //여기서 eow를 사용하지 않아서 null 처리
            //graphUtils 에서 null로 받으면 프로젝트 첫 시작을로 처리하는 로직 있음
            let eow = null;
            let interval = 7;
            
            // Flexible Graph일 때 filters 값이 우선순위
            if(this.isFlexible) {
                if(this.filters.from != '') {
                    from = this.filters.from;
                }

                if(this.filters.to != '') {
                    to = this.filters.to;
                }

                if(this.filters.interval != '') {
                    interval = this.filters.interval;
                }

                if(this.filters.eow != '') {
                    eow = this.filters.eow;
                }
            }

            let labelDateArray = generateLabelDateArray(from, to, null, interval, eow);            

            return labelDateArray;
        },

        countData(labelArray, dataArray) {

            // interval 초기화
            let interval = 7;
            if(this.isFlexible) {
                interval = this.filters.interval != '' ? this.filters.interval : interval;
            }

            interval = Number(interval);

            let countArray = [];
            let sum = 0;
            for(let i = 0; i<labelArray.length; i++) {
                let count = 0;
                let startDate = new Date(labelArray[i]);
                let endDate = new Date(startDate);

                endDate.setDate(endDate.getDate() + interval);

                dataArray.forEach(data=> {
                    let creationDate = new Date(data.date);
                    
                    if(data.status == 'TO_DO' && (startDate <= creationDate && creationDate < endDate)) {        
                        count++;
                    }                    
                });
                sum += count;
                countArray.push(count);
            }

            let series = [{
                    name: '프로그램 개수',
                    data: Array.from({length: countArray.length - 1},
                        (_, i)=>({
                            x: 0.5 + i,
                            y: countArray[i],
                            ... ({fillColor: '#1BD4D4', strokeColor: '#1BD4D4'})
                        }))
                }];
            
            this.chartOptions.xaxis.max = countArray.length - 1;
            this.chartOptions.xaxis.tickAmount = countArray.length - 1;
            // this.chartOptions.yaxis.max = Math.max(...countArray);

            // this.label = labelArray;
            this.series = series;

            this.labelArray = labelArray;
            this.chartOptions.xaxis.categories = labelArray;
            this.chartOptions.annotations.yaxis[0].y = Math.floor((sum / labelArray.length));

            // 차트를 업데이트
            if (this.$refs.apexchart) {
                this.$refs.apexchart.updateOptions(this.chartOptions);
                // this.$refs.apexchart.forceUpdate();
            }

            return series;
        },

        visualizeGraph() {
            let dataArray = this.historyData;

            if(this.isFlexible) {
                let L1 = this.filters.L1;
                let L2 = this.filters.L2;
                let L3 = this.filters.L3;
                let JOB = this.filters.JOB;
                let PRIORITY = this.filters.PRIORITY;
                let TYPE = this.filters.TYPE;
                let BUSINESS_CATEGORY = this.filters.BUSINESS_CATEGORY;

                // None 값을 ""로 변경
                L1 = L1.map(value => value === "None" ? "" : value);
                L2 = L2.map(value => value === "None" ? "" : value);
                L3 = L3.map(value => value === "None" ? "" : value);
                JOB = JOB.map(value => value === "None" ? "" : value);
                PRIORITY = PRIORITY.map(value => value === "None" ? "" : value);
                TYPE = TYPE.map(value => value === "None" ? "" : value);
                BUSINESS_CATEGORY = BUSINESS_CATEGORY.map(value => value === "None" ? "" : value);

                dataArray = dataArray.filter(item => {

                    return (
                        L1.includes(item.l1) &&
                        L2.includes(item.l2) &&
                        L3.includes(item.l3) &&
                        JOB.includes(item.job) &&
                        PRIORITY.includes(item.priority) &&
                        TYPE.includes(item.type) && 
                        BUSINESS_CATEGORY.includes(item.businessCategory) 
                    );
                });
            }

            let labelArray = this.getLabelArray();

            let series = this.countData(labelArray, dataArray);
        },
        
        reloadGraph() {
            try {
                this.loading = true;
                this.visualizeGraph();
            } catch(e) {
                this.loading = false;
                this.thereIsNoData = true;
                console.log(e);
            } finally {
                this.loading = false;
            }
        },

        // setLabels() {
        //     this.chartOptions.xaxis.categories = this.label;

        //     // 차트를 업데이트
        //     if (this.$refs.apexchart) {
        //         this.$refs.apexchart.updateOptions({
        //             xaxis: {
        //                 categories: this.label,
        //             },
        //         });
        //     }
        // },
        setTable() {
            this.tableData = this.data.table;

        },
    },
}
</script>
